import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Flex, StyleProps, Text, Tooltip } from '@bonusly/design-system';
import { useCurrentCompany } from '@bonusly/who-am-i';

import { Award } from '../../../../../../types/bonus';
import { AmountChip } from './AmountChip';

type AwardHeaderProps = StyleProps & {
	award: Award;
};

export const AwardHeader: FC<AwardHeaderProps> = ({ award, ...rest }) => {
	const { t } = useTranslation('recognition');
	const company = useCurrentCompany();

	if (!award) {
		return null;
	}

	const shouldDisplayBudget = !award.giver?.infinite_budget;

	return (
		<Flex data-testid="award-header" justifyContent="space-between" {...rest}>
			<Text fontSize="xl" fontWeight="bold" lineHeight="base" noOfLines={2}>
				{award.giver.first_name}
			</Text>

			{shouldDisplayBudget && (
				<Tooltip
					label={t('awards.give_modal.budget_tooltip', {
						amount: award.giving_balance,
						context: award.budget_period,
						defaultValue: '',
						formatParams: {
							amount: company.budget.format,
						},
					})}
				>
					<AmountChip amount={award.giving_balance} data-testid="amount-chip" ml={3} />
				</Tooltip>
			)}
		</Flex>
	);
};
